import { motion } from 'framer-motion';
import VentureCard from './VentureCard';
import { useLang } from '@/lib/LanguageContext';

export default function VenturesGrid({ ventures, ecosystemImage }) {
  const { t } = useLang();
  return (
    <section id="ventures" className="relative py-32 overflow-hidden">
      {/* Background accent */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-primary/[0.02] blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20">
          
          <span className="text-xs font-inter font-medium tracking-[0.3em] uppercase text-primary mb-4 block">
            {t('The Venture Matrix')}
          </span>
          <h2 className="font-inter font-black text-4xl md:text-5xl tracking-[-0.03em] text-foreground mb-4">
            {t('Ventures We Have Built — Proof of What We Deliver')}
          </h2>
          <p className="text-muted-foreground font-inter max-w-xl mx-auto leading-relaxed">
            {t('Every venture below was designed, engineered and launched in-house by the same team that builds for clients. Each subsidiary operates as an autonomous powerhouse, unified under the Jotunheims strategic framework.')}
          </p>
          <div className="w-16 h-px bg-primary/40 mx-auto mt-6" />
        </motion.div>

        {/* Decorative image strip */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="relative mb-16 rounded-2xl overflow-hidden h-48 md:h-64">
          
          <img
            src={ecosystemImage}
            alt="Digital ecosystem network"
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover opacity-50" />
          
          <div className="absolute inset-0 bg-gradient-to-r from-background via-background/40 to-background" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-inter font-black text-3xl md:text-5xl tracking-[-0.04em] text-foreground/80">{t('21 Ventures Built In-House')}</span>
          </div>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ventures.map((venture, i) =>
          <VentureCard key={venture.name} venture={venture} index={i} />
          )}
        </div>
      </div>
    </section>);

}